<template>
  <div style="display: grid;">
    <div class="mb-2" style="margin-left: -24px;">
      <ul class="step-menu">
        <li role="button" class="complete d-flex align-items-center">
          <img src="@/assets/image/icon/ceklis-sukses.svg" class="mr-2" alt="">
          <!-- <div class="page">1</div> -->
          <div>Customer Information</div>
        </li>
        <li role="button" class="d-flex align-items-center">
          <div class="page">2</div>
          <div>Consignee / Shipper</div>
        </li>
        <li role="button" class="d-flex align-items-center">
          <div class="page">3</div>
          <div>Billing Information</div>
        </li>
        <li role="button" class="d-flex align-items-center">
          <div class="page">4</div>
          <div>Required Documents</div>
        </li>
        <li role="button" class="d-flex align-items-center">
          <div class="page">5</div>
          <div>Additional</div>
        </li>
      </ul>
    </div>
    <div v-if="isLoadingSaf" class="_documents__container">
      <half-circle-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
      />
    </div>
    <form v-else class="scroller mt-4" @submit.prevent="submitSAF" style="margin-right: 11px;">
      <div class="d-flex mb-2">
        <div class="col-6">
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Company Name<span style="color: red;">*</span></p>
            <b-form-input
              v-model="form.companyname"
              name="Company Name"
              readonly
              class="disabled"
            />
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Company Address<span style="color: red;">*</span></p>
            <b-form-textarea
              v-model="form.companyaddress"
              name="Company Address"
              type="text"
              placeholder="Jl. Mega Kuningan Barat, Blok E.4.7,"
              rows="9"
              max-rows="6"
              style="max-height: 120px"
              readonly
              class="disabled"
            />
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Email Address<span style="color: red;">*</span></p>
            <b-form-input
              v-model="form.email"
              name="Email Address"
              readonly
              class="disabled"
            />
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Date of Incorporation<span style="color: red;">*</span></p>
            <b-form-input
              type="date"
              v-model="form.dateIncor"
              name="Date of Incorporation"
              v-validate="'required'"
              placeholder="DD/MM/YYYY"
            />
            <div class="fontstyle__errormsg">
              {{ errors.first("Date of Incorporation") }}
            </div>
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Company Size</p>
            <div class="options__multipleselect">
              <multiselect
                v-model="form.numberEmploy"
                :options="optionSize"
                label="name"
                :placeholder="'Select Company Size'"
                name="Company Size"
                :allow-empty="false"
                :show-labels="false"
              >
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/icon-arrow-blue.png"
              />
            </div>
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Industry Type<span style="color: red;">*</span></p>
            <div class="options__multipleselect">
              <multiselect
                v-model="form.nature"
                :options="getListIndustry || []"
                label="name"
                placeholder="Select Industry Type"
                v-validate="'required'"
                name="Industry"
                :state="errors.first('Industry') && false"
                :allow-empty="false"
                :show-labels="false"
              >
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/icon-arrow-blue.png"
              />
            </div>
            <p v-if="errors.has('Industry')" class="fontstyle__errormsg">
              {{ errors.first("Industry") }}
            </p>
            <!-- <b-form-input
              v-model="form.nature"
              name="industry Type"
              v-validate="'required'"
              placeholder="e.g otomotif"
            />
            <div class="fontstyle__errormsg">
              {{ errors.first("industry Type") }}
            </div> -->
          </div>
        </div>
        <div class="col-6">
          <div>
            <p style="font-weight: 400;font-size: 14px;" class="input-label">NPWP Number<span style="color: red;">*</span></p>
            <b-form-input
              v-model="form.npwp"
              maxlength="20"
              name="NPWP"
              v-validate="'required'"
              placeholder="00.000.000.0-000.000"
              @input="formatNpwp(form.npwp)"
            />
            <p class="d-flex justify-content-end" style="font-size: 10px;color: #7A7C7E;">if the Company does not have NPWP number, please fill in 00.000.000.0-000.000</p>
            <div class="fontstyle__errormsg">
              {{ errors.first("NPWP") }}
            </div>
          </div>
          <div class="mb-3">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Phone Number<span style="color: red;">*</span></p>
            <b-form-input
              v-model="form.phone"
              name="Phone Number"
              placeholder="+6281234567890"
              readonly
              class="disabled"
            />
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Fax Number</p>
            <b-form-input
              type="number"
              v-model="form.fax"
              name="Fax"
              placeholder="e.g +62129571982"
            />
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Contact Person<span style="color: red;">*</span></p>
            <b-form-input
              v-model="form.contact"
              name="Phone Number"
              placeholder="Adit"
              readonly
              class="disabled"
            />
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Job Title<span style="color: red;">*</span></p>
            <b-form-input
              v-model="form.position"
              name="Job Title"
              v-validate="'required'"
              placeholder="e.g UI Designer"
            />
            <div class="fontstyle__errormsg">
              {{ errors.first("Job Title") }}
            </div>
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Yearly Revenue</p>
            <div class="options__multipleselect">
              <multiselect
                v-model="form.annual"
                :options="optionYearlyRevenue || []"
                label="name"
                placeholder="e.g Rp.100.000.000"
                name="Revenue"
                :allow-empty="false"
                :show-labels="false"
              >
                <span slot="noResult"
                  >Oops! No elements found.</span
                >
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/icon-arrow-blue.png"
              />
            </div>
            <!-- <div class="fontstyle__errormsg">
              {{ errors.first("Revenue") }}
            </div> -->
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Customer Domicile<span style="color: red;">*</span></p>
            <div class="options__multipleselect">
              <multiselect
                v-model="form.domicile"
                :options="optionDomicile || []"
                label="name"
                placeholder="Select Domicile"
                name="Domicile"
                v-validate="'required'"
                :allow-empty="false"
                :show-labels="false"
              >
                <span slot="noResult"
                  >Oops! No elements found.</span
                >
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/icon-arrow-blue.png"
              />
            </div>
            <div class="fontstyle__errormsg">
              {{ errors.first("Domicile") }}
            </div>
          </div>
        </div>
      </div>
      <p class="ml-3 mb-2" style="font-weight: 600;font-size: 16px;color: #1D3354;">Monthly Estimated Shipment Volume</p>
      <div class="d-flex">
        <div class="col-6 mb-2">
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Choose your Shipment<span style="color: red;">*</span></p>
            <div class="options__multipleselect">
              <multiselect
                v-model="form.choose"
                :options="optionChoose || []"
                label="name"
                placeholder="Select Shipment"
                name="Type Shipment"
                v-validate="'required'"
                :allow-empty="false"
                :show-labels="false"
              >
                <span slot="noResult"
                  >Oops! No elements found.</span
                >
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/icon-arrow-blue.png"
              />
            </div>
            <div class="fontstyle__errormsg">
              {{ errors.first("Type Shipment") }}
            </div>
          </div>
          <div v-if="displayType === 'AIR CARGO AND OCEAN CARGO'">
            <p class="mb-2 mt-2" style="font-weight: 700;font-size: 14px;color: #1D3354;">1. Air Shipment</p>
            <div class="mb-2">
              <p style="font-weight: 400;font-size: 14px;" class="input-label">Choose Air Shipment<span style="color: red;">*</span></p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="form.chooseAir"
                  :options="optionChooseAir || []"
                  label="name"
                  placeholder="Select your Air Shipment"
                  name="Air Shipment"
                  v-validate="'required'"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult"
                    >Oops! No elements found.</span
                  >
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-blue.png"
                />
              </div>
              <div class="fontstyle__errormsg">
                {{ errors.first("Air Shipment") }}
              </div>
            </div>
          </div>
          <div v-if="displayAir === 'AIR CARGO' || displayAir === 'AIR CARGO AND AIR COURIR'" class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Import Air Cargo Shipment<span style="color: red;">*</span></p>
            <b-input-group size="sm" append="KG">
              <b-form-input
                type="number"
                v-model="form.importAirCargo"
                name="Import Air Cargo Shipment"
                v-validate="'required'"
                placeholder="e.g 100"
              />
            </b-input-group>
            <div class="fontstyle__errormsg">
              {{ errors.first("Import Air Cargo Shipment") }}
            </div>
          </div>
          <div v-if="displayAir === 'AIR COURIR' || displayAir === 'AIR CARGO AND AIR COURIR'" class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Import Air Courier Shipment<span style="color: red;">*</span></p>
            <b-input-group size="sm" append="KG">
              <b-form-input
                type="number"
                v-model="form.importAirCourir"
                name="Import Air Courier Shipment"
                v-validate="'required'"
                placeholder="e.g 100"
              />
            </b-input-group>
            <div class="fontstyle__errormsg">
              {{ errors.first("Import Air Courier Shipment") }}
            </div>
          </div>
          <div v-if="displayType === 'AIR CARGO AND OCEAN CARGO'">
            <p class="mb-2 mt-2" style="font-weight: 700;font-size: 14px;color: #1D3354;">2. Ocean Shipment</p>
            <div class="mb-2">
              <p style="font-weight: 400;font-size: 14px;" class="input-label">Choose Ocean Shipment<span style="color: red;">*</span></p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="form.chooseOcean"
                  :options="optionChooseOcean || []"
                  label="name"
                  placeholder="Select your Air Shipment"
                  name="Ocean Shipment"
                  v-validate="'required'"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult"
                    >Oops! No elements found.</span
                  >
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-blue.png"
                />
              </div>
              <div class="fontstyle__errormsg">
                {{ errors.first("Ocean Shipment") }}
              </div>
            </div>
          </div>
          <div v-if="displayOcean === 'FCL' || displayOcean === 'FCL AND LCL'" class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Import FCL Ocean Shipment<span style="color: red;">*</span></p>
            <b-input-group size="sm" append="Containers">
              <b-form-input
                type="number"
                v-model="form.importFCL"
                name="Import FCL Ocean Shipment"
                v-validate="'required'"
                placeholder="e.g 100"
              />
            </b-input-group>
            <div class="fontstyle__errormsg">
              {{ errors.first("Import FCL Ocean Shipment") }}
            </div>
          </div>
          <div v-if="displayOcean === 'LCL' || displayOcean === 'FCL AND LCL'" class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Import LCL Ocean Shipment<span style="color: red;">*</span></p>
            <b-input-group size="sm" append="CBM">
              <b-form-input
                type="number"
                v-model="form.importLCL"
                name="Import LCL Ocean Shipment"
                v-validate="'required'"
                placeholder="e.g 100"
              />
            </b-input-group>
            <div class="fontstyle__errormsg">
              {{ errors.first("Import LCL Ocean Shipment") }}
            </div>
          </div>
        </div>
        <div v-if="displayType !== 'OCEAN CARGO'" class="col-6 mb-2">
          <div class="mb-2">
            <div v-if="displayType === 'AIR CARGO'">
              <p style="font-weight: 400;font-size: 14px;" class="input-label">Choose Air Shipment<span style="color: red;">*</span></p>
              <div class="options__multipleselect">
                <multiselect
                  v-model="form.chooseAir"
                  :options="optionChooseAir || []"
                  label="name"
                  placeholder="Select your Air Shipment"
                  name="Air Shipment"
                  v-validate="'required'"
                  :allow-empty="false"
                  :show-labels="false"
                >
                  <span slot="noResult"
                    >Oops! No elements found.</span
                  >
                </multiselect>
                <img
                  class="options__multipleselect--imgabsolute"
                  src="@/assets/image/icon/icon-arrow-blue.png"
                />
              </div>
            </div>
            <div class="fontstyle__errormsg">
              {{ errors.first("Air Shipment") }}
            </div>
          </div>
          <div v-if="displayAir === 'AIR CARGO' || displayAir === 'AIR CARGO AND AIR COURIR'" class="mb-2" :style="displayType === 'AIR CARGO AND OCEAN CARGO' ? 'margin-top: 10.5rem;' : ''">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Export Air Cargo Shipment<span style="color: red;">*</span></p>
            <b-input-group size="sm" append="KG">
              <b-form-input
                type="number"
                v-model="form.exportAirCargo"
                name="Export Air Cargo Shipment"
                v-validate="'required'"
                placeholder="e.g 100"
              />
            </b-input-group>
            <div class="fontstyle__errormsg">
              {{ errors.first("Export Air Cargo Shipment") }}
            </div>
          </div>
          <div v-if="displayAir === 'AIR COURIR' || displayAir === 'AIR CARGO AND AIR COURIR'" class="mb-2" :style="(displayType === 'AIR CARGO AND OCEAN CARGO' && displayAir === 'AIR COURIR') ? 'margin-top: 10.5rem;' : ''">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Export Air Courier Shipment<span style="color: red;">*</span></p>
            <b-input-group size="sm" append="KG">
              <b-form-input
                type="number"
                v-model="form.exportAirCourir"
                name="Export Air Courier Shipment"
                v-validate="'required'"
                placeholder="e.g 100"
              />
            </b-input-group>
            <div class="fontstyle__errormsg">
              {{ errors.first("Export Air Courier Shipment") }}
            </div>
          </div>
          <div v-if="displayOcean === 'FCL' || displayOcean === 'FCL AND LCL'" class="mb-2" :style="displayType === 'AIR CARGO AND OCEAN CARGO' ? 'margin-top: 6.5rem;' : ''">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Export FCL Ocean Shipment<span style="color: red;">*</span></p>
            <b-input-group size="sm" append="Containers">
              <b-form-input
                type="number"
                v-model="form.exportFCL"
                name="Export FCL Ocean Shipment"
                v-validate="'required'"
                placeholder="e.g 100"
              />
            </b-input-group>
            <div class="fontstyle__errormsg">
              {{ errors.first("Export FCL Ocean Shipment") }}
            </div>
          </div>
          <div v-if="displayOcean === 'LCL' || displayOcean === 'FCL AND LCL'" class="mb-2" :style="displayOcean === 'LCL' ? 'margin-top: 6.5rem;' : ''">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Export LCL Ocean Shipment<span style="color: red;">*</span></p>
            <b-input-group size="sm" append="CBM">
              <b-form-input
                type="number"
                v-model="form.exportLCL"
                name="Export LCL Ocean Shipment"
                v-validate="'required'"
                placeholder="e.g 100"
              />
            </b-input-group>
            <div class="fontstyle__errormsg">
              {{ errors.first("Export LCL Ocean Shipment") }}
            </div>
          </div>
        </div>
        <div v-else class="col-6 mb-2">
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Choose Your Ocean Shipment<span style="color: red;">*</span></p>
            <div class="options__multipleselect">
              <multiselect
                v-model="form.chooseOcean"
                :options="optionChooseOcean || []"
                label="name"
                placeholder="Select your Ocean Shipment"
                name="Ocean Shipment"
                v-validate="'required'"
                :allow-empty="false"
                :show-labels="false"
              >
                <span slot="noResult"
                  >Oops! No elements found.</span
                >
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/icon-arrow-blue.png"
              />
            </div>
            <div class="fontstyle__errormsg">
              {{ errors.first("Ocean Shipment") }}
            </div>
          </div>
          <div v-if="displayOcean === 'FCL' || displayOcean === 'FCL AND LCL'" class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Export FCL Ocean Shipment<span style="color: red;">*</span></p>
            <b-input-group size="sm" append="Containers">
              <b-form-input
                type="number"
                v-model="form.exportFCL"
                name="Export FCL Ocean Shipment"
                v-validate="'required'"
                placeholder="e.g 100"
              />
            </b-input-group>
            <div class="fontstyle__errormsg">
              {{ errors.first("Export FCL Ocean Shipment") }}
            </div>
          </div>
          <div v-if="displayOcean === 'LCL' || displayOcean === 'FCL AND LCL'" class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Export LCL Ocean Shipment<span style="color: red;">*</span></p>
            <b-input-group size="sm" append="CBM">
              <b-form-input
                type="number"
                v-model="form.exportLCL"
                name="Export LCL Ocean Shipment"
                v-validate="'required'"
                placeholder="e.g 100"
              />
            </b-input-group>
            <div class="fontstyle__errormsg">
              {{ errors.first("Export LCL Ocean Shipment") }}
            </div>
          </div>
        </div>
      </div>
      <p class="ml-3 mb-2" style="font-weight: 600;font-size: 16px;color: #1D3354;">Finance</p>
      <div class="d-flex mb-4">
        <div class="col-6">
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Bank Name<span style="color: red;">*</span></p>
            <div class="options__multipleselect">
              <multiselect
                v-model="form.bank"
                :options="bank || []"
                label="name"
                placeholder="Select your Bank"
                name="Bank"
                v-validate="'required'"
                :allow-empty="false"
                :show-labels="false"
              >
                <span slot="noResult"
                  >Oops! No elements found.</span
                >
              </multiselect>
              <img
                class="options__multipleselect--imgabsolute"
                src="@/assets/image/icon/icon-arrow-blue.png"
              />
            </div>
            <div class="fontstyle__errormsg">
              {{ errors.first("Bank") }}
            </div>
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Finance Contact Name<span style="color: red;">*</span></p>
            <b-form-input
              v-model="form.finance"
              name="Finance Contact Name"
              v-validate="'required'"
              placeholder="Fill finance name"
            />
            <div class="fontstyle__errormsg">
              {{ errors.first("Finance Contact Name") }}
            </div>
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Finance Contact Email<span style="color: red;">*</span></p>
            <b-form-input
              v-model="form.financeEmail"
              name="Finance Contact Email"
              v-validate="'required|email'"
              placeholder="Email"
            />
            <div class="fontstyle__errormsg">
              {{ errors.first("Finance Contact Email") }}
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Bank Account Number<span style="color: red;">*</span></p>
            <b-form-input
              type="number"
              v-model="form.bankAccount"
              name="Bank Account Number"
              v-validate="'required'"
              placeholder="Fill your bank account number"
            />
            <div class="fontstyle__errormsg">
              {{ errors.first("Bank Account Number") }}
            </div>
          </div>
          <div class="mb-2">
            <p style="font-weight: 400;font-size: 14px;" class="input-label">Finance Phone Number<span style="color: red;">*</span></p>
            <b-form-input
              type="number"
              v-model="form.financePhone"
              name="Finance Phone Number"
              v-validate="'required'"
              placeholder="e.g +62871234567890"
            />
            <div class="fontstyle__errormsg">
              {{ errors.first("Finance Phone Number") }}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end align-items-center mr-4">
        <router-link to="/settings/mydocuments" class="btn btn-white-blue mr-2">Cancel</router-link>
        <div class="btn btn-white-blue mr-2" @click="saveDraft">Save Draft</div>
        <button class="btn btn-white-blue">Next</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  name: 'form1',
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      form: {
        companyname: '',
        companyaddress: '',
        npwp: '',
        email: '',
        phone: '',
        dateIncor: '',
        numberEmploy: '',
        nature: '',
        contact: '',
        domicile: '',
        fax: '',
        position: '',
        annual: '',
        choose: '',
        chooseAir: '',
        chooseOcean: '',
        bank: '',
        finance: '',
        financeEmail: '',
        bankAccount: '',
        financePhone: '',
        importAirCargo: '',
        exportAirCargo: '',
        importAirCourir: '',
        exportAirCourir: '',
        importFCL: '',
        exportFCL: '',
        importLCL: '',
        exportLCL: ''
      },
      optionChoose: [
        { name: 'Air Shipment', value: 'AIR CARGO' },
        { name: 'Ocean Shipment', value: 'OCEAN CARGO' },
        { name: 'Air & Ocean Shipment', value: 'AIR CARGO AND OCEAN CARGO' }
      ],
      optionChooseAir: [
        { name: 'Air Cargo', value: 'AIR CARGO' },
        { name: 'Air Courier', value: 'AIR COURIR' },
        { name: 'Air Cargo & Air Courier', value: 'AIR CARGO AND AIR COURIR' }
      ],
      optionChooseOcean: [
        { name: 'FCL', value: 'FCL' },
        { name: 'LCL', value: 'LCL' },
        { name: 'FCL & LCL', value: 'FCL AND LCL' }
      ],
      optionSize: [
        { id: '&lt; 50 people', name: '<50 people' },
        { id: '50 - 100 people', name: '50 - 100 people' },
        { id: '100 - 500 people', name: '100 - 500 people' },
        { id: '500 - 1000 people', name: '500 - 1000 people' },
        { id: '&gt; 1000 people', name: '>1000 people' }
      ],
      optionYearlyRevenue: [
        { name: '<= IDR 50.000.000.000', id: '&le; IDR 50.000.000.000' },
        { name: '> IDR 50.000.000.000', id: '&gt; IDR 50.000.000.000' }
      ],
      optionDomicile: [
        { name: 'Jabodetabek' },
        { name: 'Non Jabodetabek' }
      ],
      displayType: '',
      displayAir: '',
      displayOcean: ''
    }
  },
  created () {
    this.$eventHub.$on('dialog-payload-save-draft', this.fetchSaf)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-payload-save-draft')
  },
  computed: {
    ...mapGetters({
      getListIndustry: 'auth/getListIndustry',
      errorGetListIndustry: 'auth/errorGetListIndustry',
      isLoadingGetListIndustry: 'auth/isLoadingGetListIndustry',

      account: 'settingAccount/account',

      saf: 'settingSaf/saf',
      errorSaf: 'settingSaf/errorSaf',
      isLoadingSaf: 'settingSaf/isLoadingSaf',
      isErrorPostsaf: 'settingSaf/isErrorPostsaf',

      bank: 'settingSaf/bank'
    })
  },
  watch: {
    'form.choose' (data) {
      if (!this.saf.shipment.air_cargo_shipment.air_cargo_shipment) {
        this.form.chooseAir = ''
      }
      if (!this.saf.shipment.ocean_cargo_shipment.ocean_cargo_shipment) {
        this.form.chooseOcean = ''
      }
      this.displayAir = ''
      this.displayOcean = ''
      this.displayType = ''
      if (data) {
        this.displayType = data.value
      }
    },
    'form.chooseAir' (data) {
      if (data) {
        this.displayAir = data.value
      }
    },
    'form.chooseOcean' (data) {
      if (data) {
        this.displayOcean = data.value
      }
    }
  },
  async mounted () {
    await this.fetchSaf()
    await this.fetchBank()
    await this.fetchAccount()
    localStorage.removeItem('data')
  },
  methods: {
    async fetchSaf () {
      await this.$store.dispatch('settingSaf/FETCH_SAF_SAVE_DRAFT').then(() => {
        if (this.saf) {
          const data = this.saf
          this.$store.dispatch('auth/GET_LIST_INDUSTRY').then(() => {
            this.getListIndustry.filter((element) => {
              if (element.name === data.customer_information.industry_type) {
                this.form.nature = element
              }
            })
          })
          this.form.companyname = data.customer_information.company_name
          this.form.companyaddress = data.customer_information.company_address
          this.form.phone = `${data.customer_information.phone_number}`
          this.form.npwp = data.customer_information.npwp_number
          this.form.email = data.customer_information.email
          this.form.contact = data.customer_information.contact_person
          this.form.position = data.customer_information.position
          this.form.fax = data.customer_information.fax_number
          this.form.dateIncor = data.customer_information.date_of_incorporation

          this.$store.dispatch('settingSaf/FETCH_SAF_BANK').then(() => {
            this.bank.filter((element) => {
              if (element.name === data.finance.bank_name) {
                this.form.bank = element
              }
            })
          })
          this.form.bankAccount = data.finance.bank_account_number
          this.form.finance = data.finance.finance_contact_name
          this.form.financePhone = data.finance.finance_phone_number
          this.form.financeEmail = data.finance.finance_contact_email
          this.form.importAirCargo = data.shipment.air_cargo_shipment.import_air_cargo_shipment
          this.form.exportAirCargo = data.shipment.air_cargo_shipment.export_air_cargo_shipment
          this.form.importAirCourir = data.shipment.air_cargo_shipment.import_air_courier_shipment
          this.form.exportAirCourir = data.shipment.air_cargo_shipment.export_air_courier_shipment

          this.form.importFCL = data.shipment.ocean_cargo_shipment.import_fcl
          this.form.exportFCL = data.shipment.ocean_cargo_shipment.export_fcl
          this.form.importLCL = data.shipment.ocean_cargo_shipment.import_lcl
          this.form.exportLCL = data.shipment.ocean_cargo_shipment.export_lcl
          this.optionDomicile.filter((element) => {
            if (element.name === data.customer_information.domicile) {
              this.form.domicile = element
            }
          })
          this.optionSize.filter((element) => {
            if (element.name === data.customer_information.number_of_employee) {
              this.form.numberEmploy = element
            }
          })
          this.optionYearlyRevenue.filter((element) => {
            if (element.id === data.customer_information.annual_revenue) {
              this.form.annual = element
            }
          })
          this.optionChoose.filter((element) => {
            if (element.value === data.shipment.shipment_type) {
              this.form.choose = element
            }
          })
          this.optionChooseAir.filter((element) => {
            if (element.value === data.shipment.air_cargo_shipment.air_cargo_shipment) {
              this.form.chooseAir = element
            }
          })
          this.optionChooseOcean.filter((element) => {
            if (element.value === data.shipment.ocean_cargo_shipment.ocean_cargo_shipment) {
              this.form.chooseOcean = element
            }
          })
          this.optionYearlyRevenue.filter((element) => {
            if (element.name === data.customer_information.annual_revenue) {
              this.form.annual = element
            }
          })
          this.optionSize.filter((element) => {
            if (element.id === data.customer_information.number_of_employee) {
              this.form.numberEmploy = element
            }
          })
        }
      })
    },
    async fetchAccount () {
      await this.$store.dispatch('settingAccount/FETCH_ACCOUNT')
    },
    async fetchBank () {
      await this.$store.dispatch('settingSaf/FETCH_SAF_BANK')
    },
    async getIndustryList () {
      await this.$store.dispatch('auth/GET_LIST_INDUSTRY')
    },
    submitSAF () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const payload = {
            npwp_number: this.form.npwp,
            fax_number: this.form.fax,
            date_of_incorporation: this.form.dateIncor ? this.form.dateIncor : null,
            company_name: this.form.companyname,
            company_address: this.form.companyaddress,
            contact_person: this.form.contact,
            email: this.form.email,
            phone_number: this.form.phone,
            position: this.form.position,
            annual_revenue: this.form.annual ? this.form.annual.id : null,
            number_of_employee: this.form.numberEmploy ? this.form.numberEmploy.id : null,
            domicile: this.form.domicile ? this.form.domicile.name : null,
            industry_type: this.form.nature ? this.form.nature.name : null,
            bank_name: this.form.bank.name,
            bank_account_number: this.form.bankAccount,
            finance_contact_name: this.form.finance,
            finance_phone_number: this.form.financePhone,
            finance_contact_email: this.form.financeEmail,
            shipment: {
              shipment_type: this.displayType,
              air_cargo_shipment: {
                air_cargo_shipment: this.displayAir,
                import_air_cargo_shipment: this.form.importAirCargo,
                export_air_cargo_shipment: this.form.exportAirCargo,
                import_air_courier_shipment: this.form.importAirCourir,
                export_air_courier_shipment: this.form.exportAirCourir
              },
              ocean_cargo_shipment: {
                ocean_cargo_shipment: this.displayOcean,
                import_fcl: this.form.importFCL,
                export_fcl: this.form.exportFCL,
                import_lcl: this.form.importLCL,
                export_lcl: this.form.exportLCL
              }
            }
          }
          const data = JSON.stringify(payload)
          localStorage.setItem('data', data)
          this.onSelectedTab()
        }
      })
    },
    async saveDraft () {
      const payload = {
        npwp_number: this.form.npwp,
        fax_number: this.form.fax,
        date_of_incorporation: this.form.dateIncor ? this.form.dateIncor : null,
        company_name: this.form.companyname,
        company_address: this.form.companyaddress,
        contact_person: this.form.contact,
        email: this.form.email,
        phone_number: this.form.phone,
        position: this.form.position,
        annual_revenue: this.form.annual ? this.form.annual.id : null,
        number_of_employee: this.form.numberEmploy ? this.form.numberEmploy.id : null,
        domicile: this.form.domicile ? this.form.domicile.name : null,
        industry_type: this.form.nature ? this.form.nature.name : null,
        bank_name: this.form.bank.name,
        bank_account_number: this.form.bankAccount,
        finance_contact_name: this.form.finance,
        finance_phone_number: this.form.financePhone,
        finance_contact_email: this.form.financeEmail,
        shipment: {
          shipment_type: this.displayType,
          air_cargo_shipment: {
            air_cargo_shipment: this.displayAir,
            import_air_cargo_shipment: this.form.importAirCargo,
            export_air_cargo_shipment: this.form.exportAirCargo,
            import_air_courier_shipment: this.form.importAirCourir,
            export_air_courier_shipment: this.form.exportAirCourir
          },
          ocean_cargo_shipment: {
            ocean_cargo_shipment: this.displayOcean,
            import_fcl: this.form.importFCL,
            export_fcl: this.form.exportFCL,
            import_lcl: this.form.importLCL,
            export_lcl: this.form.exportLCL
          }
        }
      }
      this.$emit('Draft', payload)
    },
    formatNpwp (value) {
      value = value.replace(/[A-Za-z\W\s_]+/g, '')
      let split = 6
      const dots = []

      for (let i = 0, len = value.length; i < len; i += split) {
        split = i >= 2 && i <= 6 ? 3 : i >= 8 && i <= 12 ? 4 : 2
        dots.push(value.substr(i, split))
      }

      const temp = dots.join('.')
      let npwp = temp.length > 12 ? `${temp.substr(0, 12)}-${temp.substr(12, 7)}` : temp

      this.form.npwp = npwp
    },
    onSelectedTab () {
      this.$emit('Next', 'form2')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/saf/form1.vue